<!-- 函询 -->
<template>
  <div class="button">
    <div @click.stop="inByLetDialogClick(item)">
      <img style="width:20px;height:20px" src="@/assets/hideBox/hanxun.png" alt />
      <span>函询</span>
    </div>
    <!-- 函询弹框 -->
    <InByLetDialog
      :dialogVisible="inByLetDialogShow"
      @closeDialog="inByLetDialogShow = false"
      @cancelDialog="inByLetDialogShow = false"
      @confirmDialog="confirminDialog"
      :item="item"
    ></InByLetDialog>
  </div>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import { checkDataStatusMessage } from "@/utils/checkDataStatus"

export default {
  name: "mail",
  inject: ["cardListCom"],
  props: {
    item: Object,
    type: {
      type: [Number, String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  components: {
    InByLetDialog: () => import("@/components/public/InquiryLetterDialog") // 函询弹框
  },
  data() {
    return {
      inByLetDialogShow: false
    }
  },
  methods: {
    /** @name 函询 */
    async inByLetDialogClick(item) {
      if (this.permissionTips()) return
      let no = this.item.no
      if (this.$parent.type == 2) {
        no = this.item.companyNo
      }
      const dataState = await checkDataStatusMessage.call(
        this,
        this.$parent.type,
        no
      )
      if (!dataState || dataState != 1) {
        return
      }
      if (item.publishType == 1) {
        this.$message.error("暂时无法函询！")
        return
      }
      if (
        item.userNo === this.$parent.userNo ||item.createUserNo=== this.$parent.userNo ||item.user_no === this.$parent.userNo
      ) {
        this.$message.error("操作失败，不能对自己发布的内容进行该操作")
        return
      }
      // else if (item.companyNo === this.$parent.companyNo) {
      //   this.$message.error("不能函询当前加入的公司！")
      //   return
      // }
      else if (this.type == 2) {
        //工程公司函询自己加入的不能函询
        if (item.companyNo === this.$parent.companyNo) {
          this.$message.error("不能函询当前加入的公司！")
          return
        }
      }
      this.inByLetDialogShow = true
    },
    /** @name 函询提交 */
    async confirminDialog(obj) {
      if(this.type == 7){
        obj.markId = this.item.teamNo
      }else{
        obj.markId = this.item.no
      }
      obj.companyNo = this.item.companyNo ? this.item.companyNo : ""
      obj.markCreateNo = this.item.userNo
      if (this.type == 1) {
        obj.markName = this.item.teamName
        obj.title = `【${this.item.teamTypeName}】` + this.item.teamName
        obj.markType = 1
      } else if (this.type == 2) {
        obj.markName = this.item.name
        obj.title = "【工程公司】" + this.item.name
        obj.markType = 2
        obj.markCreateNo = this.item.createUser
      } else if (this.type == 3) {
        obj.markName = "专业工人"
        obj.title = "【专业工人】" + this.item.name
        obj.markType = 3
        obj.markCreateNo = this.item.userNo
      } else if (this.type == 4) {
        obj.markName = this.item.projectName
        obj.title = "【临时用工】" + this.item.projectName
        obj.markType = 4
        obj.markCreateNo = this.item.userNo
      } else if (this.type == 5) {
        obj.markName = this.item.categoryName.split("-").length>=3 ? this.item.categoryName.split("-")[2] : this.item.categoryName.split("-")[ this.item.categoryName.split("-").length-1]
        obj.title = "【工种报价】" + `${this.item.categoryName.split("-").length>=3 ? this.item.categoryName.split("-")[2] : this.item.categoryName.split("-")[ this.item.categoryName.split("-").length-1]}`
        obj.markType = 5
        obj.markCreateNo = this.item.userNo
      } else if (this.type == 6) {
        obj.markName = this.item.workName
        obj.title = "【劳务用工】" + this.item.workName
        obj.markType = 6
        obj.markCreateNo = this.item.createUserNo
      }else if (this.type == 7) {//班组找活函询绑定的工队
        obj.markName = this.item.teamName
        obj.title = "【班组工队】" + this.item.teamName
        obj.markType = 7
        obj.markCreateNo = this.item.userNo
      }
      let res = await apiResignAll.getaddEnquire(obj)
      if (res.data.code === 200) {
        this.$message.success("提交成功")
        this.inByLetDialogShow = false
      } else {
        this.$message.error("提交失败")
      }
    }
  }
}
</script>

<style scoped>
</style>
